// import { Link } from 'react-router-dom'
// import BrandOne from './Images/brand_1.png'
// import BarndTwo from './Images/brand_2.png'
// import BrandThree from './Images/brand_3.png'
// import BrandFour from './Images/brand_4.png'
// import BrandFive from './Images/brand_5.png'
// function Brands() {
//   return (
//     <div className="brand">
//       <div className="brand-run">
//         <div className="brand-one d-flex align-items-center">
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//           <Link to='/'> <img src={BrandThree} /></Link>
//           <Link to='/'> <img src={BrandFour} /></Link>
//           <Link to='/'> <img src={BrandFive} /></Link>
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//           <Link to='/'> <img src={BrandThree} /></Link>
//           <Link to='/'> <img src={BrandFour} /></Link>
//           <Link to='/'> <img src={BrandFive} /></Link>
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//           <Link to='/'> <img src={BrandThree} /></Link>
//           <Link to='/'> <img src={BrandFour} /></Link>
//           <Link to='/'> <img src={BrandFive} /></Link>
//         </div>
//         <div className="brand-two d-flex align-items-center">
//           <Link to='/'> <img src={BrandFive} /></Link>
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//           <Link to='/'> <img src={BrandThree} /></Link>
//           <Link to='/'> <img src={BrandFour} /></Link>
//           <Link to='/'> <img src={BrandFive} /></Link>
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//           <Link to='/'> <img src={BrandThree} /></Link>
//           <Link to='/'> <img src={BrandFour} /></Link>
//           <Link to='/'> <img src={BrandFive} /></Link>
//           <Link to='/'> <img src={BrandOne} /></Link>
//           <Link to='/'> <img src={BarndTwo} /></Link>
//         </div>
//       </div>
//     </div>
//   )
// }
// export default Brands;
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { brandsBanner } from '../../network/api/banner.js';
import { link } from '../../config.js';
import axios from 'axios';

function Brands({id}) {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    // const fetchBrands = async () => {
    //   try {
    //     const response = await brandsBanner(id);
    //     setBrands(response.data);
    //   } catch (error) {
    //     console.error('Error fetching brands:', error);
    //   }
    // };
    const fetchBrands = async () => {
      try {
        const {data} = await await axios.get(`${link}brands/products`);
        setBrands(data.brands);
      
        
      } catch (error) {
        console.error('Error fetching brands:', error);
      }
    };

    fetchBrands();
  }, [id]);

  return (
   brands.length>0 &&(
    <div className="brand">
    <div className="brand-run">
      <div className="brand-one d-flex align-items-center">
        {brands.map((brand, index) => (
          <Link key={index} to={brand?.linkUrl}>
            <img src={brand?.banner[0]?.secure_url} width={100} height={100} alt={`Brand ${index + 1}`} />
          </Link>
        ))}

      </div>
      <div className="brand-two d-flex align-items-center">
      {brands.map((brand, index) => (
          <Link key={index} to={brand?.linkUrl}>
            <img src={brand?.banner[0]?.secure_url} width={100} height={100} alt={`Brand ${index + 1}`} />
          </Link>
        ))}
       </div>
       
    </div>
  </div>
   )
  );
}

export default Brands;
